var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58573 0L5.90573 0.580313L3.90573 6.38342C6.46573 6.38342 10.0657 7.29534 10.0657 10.943C10.0657 13.8446 8.06573 16 5.10573 16C1.98573 16 -0.0142726 13.3471 0.385728 10.2798C0.945728 6.96373 2.94573 2.07254 3.58573 0ZM17.1857 0L19.5057 0.580313L17.5057 6.38342C20.0657 6.38342 23.6657 7.29534 23.6657 10.943C23.6657 13.8446 21.6657 16 18.7057 16C15.5857 16 13.5857 13.3471 13.9857 10.2798C14.5457 6.96373 16.5457 2.07254 17.1857 0Z",
    fill: "#1B1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.54555f037c1b0eb2ef9b5d853dd9c506.svg";
export { ForwardRef as ReactComponent };